import "../src/global/global-pc"
import "@modules/advert-cards/advert-cards"
import "@modules/advert-cards/home"
import "@modules/browser-extension/open-with-gesamt-icons.css"

import "@modules/tracking/previous-next-advert-cookie"

import "@modules/top-adverts/top-adverts"

import "@modules/vue-modals/ad-free"
import "@modules/location/LocationSelector"
import "@modules/solads/solads"
import "@modules/community/pc.css"

import { initSwiperContainer } from "@modules/util/swiper.ts"
import type { SwiperContainer } from "swiper/element"
import { Autoplay, FreeMode, Navigation } from "swiper/modules"
import type { SwiperOptions } from "swiper/types"
import "@modules/home/home-pc.css"

import "@modules/events-slider/events-slider"
import "@modules/more-container"
import "@modules/util/Scrolling.ts"
import "@modules/news/news-star-icon.css"

import {
    setAZMFilterPath,
    setFilterPathLocationToSessionStorage,
} from "@modules/global/filter-path/filter-path-handler.ts"

setFilterPathLocationToSessionStorage("home")
setAZMFilterPath()

const swiperContainer = document.querySelector("#muenchen-highlight-container") as SwiperContainer
requestAnimationFrame(() => {
    initSwiperContainer(swiperContainer, {
        navigation: {
            enabled: true,
            nextEl: "#munich-swiper-button-next",
            prevEl: "#munich-swiper-button-prev",
        },
        loop: true,
        pagination: false,
        modules: [Autoplay, Navigation, FreeMode],
        allowSlideNext: true,
        allowSlidePrev: true,
        slidesPerView: 4,
        setWrapperSize: true,
        loopAdditionalSlides: 4,
        breakpoints: {
            0: {
                slidesPerView: 2,
                spaceBetween: -95,
            },
            990: {
                slidesPerView: 3,
                spaceBetween: -65,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: -60,
            },
        },
        speed: 1500,
        autoplay: { delay: 0 },
    } as SwiperOptions)
})

let timer = null as Timer | null
swiperContainer?.addEventListener("mouseleave", () => {
    const swiper = swiperContainer.swiper

    timer = setTimeout(() => {
        swiper.autoplay.start()
        swiper.autoplay.resume()
    }, 2000)
})

swiperContainer?.addEventListener("mouseenter", () => {
    const swiper = swiperContainer.swiper

    if (timer !== null) {
        clearTimeout(timer)
    }

    swiper.autoplay.pause()
    swiper.autoplay.stop()
})

const adventSwiperContainer = document.querySelector<SwiperContainer>("#city-highlights-container")
if (adventSwiperContainer !== null) {
    initSwiperContainer(adventSwiperContainer, {
        navigation: {
            enabled: false,
            nextEl: "#swiper-button-next",
            prevEl: "#swiper-button-prev",
        },
        loop: true,
        pagination: false,
        modules: [Navigation],
        allowSlideNext: true,
        allowSlidePrev: true,
        slidesPerView: 1,
        setWrapperSize: true,
        on: {
            breakpoint(swiper) {
                for (const slide of Object.values(swiper.slides)) {
                    if (slide.classList.contains("swiper-slide-blank")) {
                        slide.parentElement?.removeChild(slide)
                    }
                }
                // force loop re-init
                swiper.loopDestroy()
                swiper.loopCreate()
                swiper.update()
            },
        },
    } as SwiperOptions)
}
